<template>
    <div class="smart-portfolio__item">
        <div class="smart-portfolio__inside">
            <VueSlickCarousel
                :ref="`sliderBig${uuid}`"
                :asNavFor="$refs.sliderThumb"
                :dots="false"
                :arrows="false"
                :draggable="false"
                :focusOnSelect="true"
                class="_slider_top"
                @beforeChange="syncSliders"
            >
                <div class="_item" v-for="(url, key) in images" :key="key">
                    <img :src="url" :alt="name" />
                </div>
            </VueSlickCarousel>

            <VueSlickCarousel
                :ref="`sliderThumb${uuid}`"
                :asNavFor="$refs.sliderBig"
                :focusOnSelect="true"
                class="_slider_bottom"
                @beforeChange="syncSliders"
                v-bind="thumbSliderOptions"
                @swipe="test"
            >
                <!-- @swipe.capture="test" -->
                <div
                    class="_item_bottom"
                    v-for="(item, key) in images"
                    :key="key"
                >
                    <img :src="`https://rolatex.ru${item}`" :alt="name" />
                </div>

                <template #customPaging>
                    <VueSlickCarouselDot />
                </template>
            </VueSlickCarousel>
        </div>
        <div class="smart-portfolio__content">
            <h3 class="_title">{{ name }}</h3>
            <p class="_text">
                {{ text }}
            </p>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import VueSlickCarouselDot from './VueSlickCarouselDot.vue';
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
    name: 'slider',
    components: {
        VueSlickCarousel,
        VueSlickCarouselDot,
    },
    props: {
        images: Array,
        text: String,
        name: String,
        uuid: String,
    },

    data() {
        return {
            thumbSliderOptions: {
                dots: true,
                arrows: false,
                swipe: false,
                swipeToSlide: false,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 4000,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite: true,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },
        };
    },
    methods: {
        test(e, w) {
            // e.stopPropagation();

            console.log('test', e, w);
        },

        syncSliders(currentPosition, nextPosition) {
            this.$refs['sliderBig' + this.uuid].goTo(nextPosition);
            this.$refs['sliderThumb' + this.uuid].goTo(nextPosition);
        },
    },
};
</script>

<style>
.slick-dots {
    display: flex !important;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    min-height: 50px;
    padding-left: 60px;
    padding-right: 60px;
}
</style>
